const Roles = {
    ALL: "ALL",
    EP_SUPER_USER: "EP_SUPER_USER",
    LITE_EP_SUPER_USER: "LITE_EP_SUPER_USER",
    OPERATOR: "OPERATOR",
    MANAGER: "MANAGER"
}

export default Roles;